import type { Region } from '~~/core/entities/Region';

import {
	PropertyTypeEnum,
	PropertyTypePlurals
} from '~/core/entities/CRMEnums';
import { REGION_PROPERTY_TYPE_ORDER } from '~/utils/regionPropertyTypeOrder';

export const MAX_FEATURED_REGION_PROPERTY_TYPE_TAGS = 7;

export interface FeaturedRegionPropertyTypeLink {
	label: string;
	propertyType: PropertyTypeEnum;
}

function isPropertyType(value: string): value is PropertyTypeEnum {
	return Object.values(PropertyTypeEnum).includes(value as PropertyTypeEnum);
}

function getAvailablePropertyTypes(region: Region): Set<PropertyTypeEnum> {
	const availablePropertyTypes = new Set<PropertyTypeEnum>();

	region.typologies?.forEach(typology => {
		if (isPropertyType(typology.propertyType)) {
			availablePropertyTypes.add(typology.propertyType);
		}
	});

	if (!availablePropertyTypes.size) {
		region.topPropertyTypes?.forEach(propertyType => {
			if (isPropertyType(propertyType)) {
				availablePropertyTypes.add(propertyType);
			}
		});
	}

	return availablePropertyTypes;
}

function hasPropertyTypeAvailabilityData(region: Region): boolean {
	return (
		Array.isArray(region.typologies) || Array.isArray(region.topPropertyTypes)
	);
}

export function getFeaturedRegionPropertyTypeLinks(
	region: Region
): FeaturedRegionPropertyTypeLink[] {
	const availablePropertyTypes = getAvailablePropertyTypes(region);
	const propertyTypes = hasPropertyTypeAvailabilityData(region)
		? REGION_PROPERTY_TYPE_ORDER.filter(propertyType =>
				availablePropertyTypes.has(propertyType)
			)
		: REGION_PROPERTY_TYPE_ORDER;

	return propertyTypes
		.slice(0, MAX_FEATURED_REGION_PROPERTY_TYPE_TAGS)
		.map(propertyType => ({
			label: PropertyTypePlurals[propertyType],
			propertyType
		}));
}
